export const translation = {
  'common': {
    'apply': 'Apply',
    'back': 'Back',
    'cancel': 'Cancel',
    'caregiverLabel': 'Caregiver:',
    'familyLabel': 'Family:',
    'close': 'Close',
    'continue': 'Continue',
    'copy': 'Copy',
    'decline': 'Decline',
    'delete': 'Delete',
    'distance': 'Distance',
    'edit': 'Edit',
    'email': 'Email',
    'link': 'Link',
    'linkCopied': 'Link copied to clipboard',
    'loading': 'Loading...',
    'location': 'Location',
    'name': 'Name',
    'next': 'Next',
    'noCaregivers': 'No caregivers found. Try a different zip code.',
    'ok': 'OK',
    'or': 'or',
    'other': 'Other',
    'phone': 'Phone',
    'previous': 'Previous',
    'remove': 'Remove',
    'save': 'Save',
    'saved': 'Saved.',
    'search': 'Search',
    'settings': 'Settings',
    'share': 'Share',
    'signUp': 'Sign Up',
    'submit': 'Submit',
    'supportEmail': 'support@urbansitter.com',
    'timeRange': '{{start}} – {{end}}',
    'connected': 'Connected',
    'privacyPolicy': 'Privacy Policy',
    'viewBookings': 'View bookings',
    'reportIssue': 'Report an issue',
    'moreOptionsAriaLabel': 'More options',
    'noLongerActive': '{{name}} is no longer active',
    'bookingCount_one': '{{count}} booking with you',
    'bookingCount_other': '{{count}} bookings with you',
    'distanceUnder1': '< 1 mile',
    'distanceMiles': '{{distance}} miles',
    'urbansitter': 'UrbanSitter',
    'urbansitterAvatar': 'UrbanSitter avatar',
    'zipCode': 'Zip code',
    'frequencies': {
      'specificDate': 'Specific date',
      'partTime': 'Part-time',
      'fullTime': 'Full-time'
    },
    'verticals': {
      'childcare': 'Child care',
      'petCare': 'Pet care',
      'seniorCare': 'Senior care',
      'householdServices': 'Household services'
    },
    'verticalLabels': {
      'childCare': 'Child Care',
      'petCare': 'Pet Care',
      'seniorCare': 'Senior Care',
      'householdServices': 'Household Services',
      'dayCare': 'Daycare'
    },
    'pets': {
      'heading': 'Pets',
      'notesLabel': 'Notes:',
      'cycleHint': 'Click to cycle: Yes → No → Unset',
      'hasDogsCount': 'Has dog(s)',
      'noDogsCount': 'No dog(s)',
      'notSpecifiedDogs': 'Not specified dog(s)',
      'hasCatsCount': 'Has cat(s)',
      'noCatsCount': 'No cat(s)',
      'notSpecifiedCats': 'Not specified cat(s)',
      'hasOtherPetsCount': 'Has other pet(s)',
      'noOtherPetsCount': 'No other pet(s)',
      'notSpecifiedOtherPets': 'Not specified other pet(s)',
      'dogPrompt': 'Dog?',
      'hasDogs': 'Has dog(s)',
      'noDogs': 'No dogs',
      'catPrompt': 'Cat?',
      'hasCats': 'Has cat(s)',
      'noCats': 'No cats',
      'otherPetPrompt': 'Other pets?',
      'hasOtherPets': 'Has other pets',
      'noOtherPets': 'No other pets'
    },
  },
  'components': {
    'bookingAcceptCreditCard': {
      'header': "You're accepting a credit card booking",
      'description': 'Before you accept this booking request. confirm that you expect to be paid by the family by credit card and will not negotiate with the family to be paid in cash',
      'checkboxDescription': 'I confirm that I expect to be paid by credit card for this booking and will need to activate my payout account in order to receive my funds',
      'cta': 'Accept booking'
    },
    'facilitySearchCard': {
      'ageRanges': 'Age Ranges',
      'ariaLabel': 'View details for {{facilityName}}',
      'careTypes': 'Care Types',
      'distance': 'Distance',
      'facilityType': 'Facility Type',
      'location': 'Location',
      'licenseInformation': 'License Information',
      'licenseLinkTitle': 'Open license information in new tab',
      'noReviews': 'Not yet reviewed',
      'openSpots': 'Open spots!',
      'rating': 'Rating',
      'readMore': 'Read more',
      'review': 'Review',
      'reviews': 'Reviews',
      'schedule': 'Schedule',
      'specialOffer': 'Special Offer',
      'tuition': 'Tuition',
      'license': 'License',
      'registration': 'Registration',
    },
    'feedback': {
      'anythingElse': "Is there anything you'd like to share with us?",
      'disclaimer': 'Feedback submitted through this form may not receive an individual response. If you have a question or need help resolving a problem, contact our Support Team by navigating to the <supportLink>Help section</supportLink> or emailing <supportEmail>support@urbansitter.com</supportEmail>.',
      'header': 'Let us know how UrbanSitter is doing.',
      'notLikely': 'Not likely',
      'sendFeedback': 'Send feedback',
      'specificFeedbackLabel': 'Specific feedback',
      'subheader': 'How likely is it that you would recommend UrbanSitter?',
      'veryLikely': 'Very likely',
    },
    'greeting': {
      'morning': 'Good morning,',
      'afternoon': 'Good afternoon,',
      'evening': 'Good evening,',
    },
    'jobCard': {
      'postedBy': 'Posted {{timeAgo}}',
      'jobRate': '${{jobRate}} /hr',
      'jobHours': 'for {{jobHours}} hours',
      'negotiableRate': 'Rate dependent on experience'
    },
    'passwordChange': {
      'requirements': 'New password must meet the following requirements:',
      'requirementsList': {
        'minLength': '8 character minimum',
        'lowercase': '1 lowercase letter',
        'uppercase': '1 uppercase letter',
        'number': '1 number',
        'symbol': '1 symbol'
      },
      'failures': {
        'tooShort': 'Password must be at least 8 characters.',
        'noLower': 'Password must include a lowercase letter.',
        'noUpper': 'Password must include an uppercase letter.',
        'noDigit': 'Password must include a number.',
        'noSymbol': 'Password must include a symbol.'
      },
      'strength': {
        'empty': '',
        'weak': 'Weak password',
        'medium': 'Medium password',
        'good': 'Good password',
        'strong': 'Strong password'
      },
      'currentPasswordAriaLabel': 'Current password',
      'currentPasswordPlaceholder': 'Verify current password',
      'newPasswordPlaceholder': 'Enter your new password',
      'repeatPasswordPlaceholder': 'Repeat your new password',
      'passwordMismatch': 'Passwords must match.',
      'passwordsDoNotMatch': 'Passwords do not match.',
      'cancel': 'Cancel'
    },
    'passwordInput': {
      'showPassword': 'Show password',
      'hidePassword': 'Hide password',
      'seePassword': 'See password'
    },
    'jobPostCard': {
      'edit': 'Edit job post',
      'hasApplied': 'caregiver has applied.',
      'haveApplied': 'caregivers have applied.',
      'noApplicants': 'No caregivers have applied yet.',
      'postAnother': 'Post another job',
      'savedSearchUpsell': 'Try a saved search and get instant updates that match your criteria.',
      'viewApplicants': 'View applicants'
    },
    'notifications': {
      'none': 'You have no new notifications.',
      'viewAll': 'View all notifications',
    },
    'search': {
      'distance': 'Distance',
      'frequency': 'Frequency',
      'location': 'Location',
      'lookingFor': 'Looking for',
      'zipError': 'Please enter a valid ZIP code.'
    },
    'speechRecognition': {
      'startVoiceInput': 'Start voice input',
      'stopRecording': 'Stop recording'
    },
    'generalAvailability': {
      'closeConfirmation': {
        'areYouSure': 'Are you sure?',
        'details': 'You currently have no availability listed on your calendar. This means few families will see your profile.*',
        'dismiss': 'Dismiss',
        'goBack': 'Go back',
        'subtext': '*75% of families use the search tool to see who is available.'
      },
      'cancel': 'Cancel',
      'details': 'Providing your schedule allows us to notify you about matching job posts. This also helps families see if your schedule is a match. Deselect any availability that you can\'t work. You can customize your calendar in more detail later.',
      'deselectAny': "Deselect any that don't apply",
      'fullTime': 'Full-time jobs',
      'fullTimeHours': '(more than 25 hours)',
      'generallyAvailable': 'When are you generally available?',
      'hi': 'Hi',
      'labelSunday': 'S',
      'labelMonday': 'M',
      'labelTuesday': 'T',
      'labelWednesday': 'W',
      'labelThursday': 'T',
      'labelFriday': 'F',
      'labelSaturday': 'S',
      'letsFindJobs': "Let's find jobs that match your schedule.",
      'never': 'Never',
      'noUpcomingAvailability': 'You currently have no upcoming availability on UrbanSitter. The first step in getting a new job is showing families that your schedule can match theirs. Add yours today!',
      'occasional': 'Occasional jobs',
      'partTime': 'Part-time jobs',
      'partTimeHours': '(25 hours or less)',
      'save': 'Save',
      'saveError': 'There was an error saving your availability. Please try again.',
      'timeEarly': 'Early (5 - 8am)',
      'timeMorning': 'Morning (8am - 12pm)',
      'timeAfternoon': 'Afternoon (12 - 5pm)',
      'timeEvening': 'Evening (5 - 11pm)',
      'timeOvernight': 'Overnight (11pm - 5am)',
      'timeNever': 'Never available',
      'whatJobs': 'What jobs are you looking for?'
    },
    'partnerWithCredits': {
      'back': 'Back',
      'browse': 'Browse',
      'cancel': 'Cancel',
      'goTo': 'Go to',
      'chooseTheAmount': 'Choose the amount to transfer from UrbanSitter to {{ partner }}:',
      'creditBalance': 'Credits eligible to transfer',
      'creditsTransferred': 'Credits previously transferred',
      'learnMore': 'Learn more',
      'logoAlt': '{{ partner }} logo',
      'transfer': 'Transfer credits',
      'transferHeading': 'Transfer credits to {{ partner }}',
      'transferSuccessful': 'Transfer successful',
      'outschool': {
        'intro': 'Instantly transfer your UrbanSitter credits to Outschool for individual or group sessions with 4,000+ top rated, vetted tutors.',
        'baseUrl': 'https://outschool.com/?adminTags=urban_sitter',
        'successUrl': 'https://outschool.com/online-classes/tutoring?adminTags=urban_sitter',
        'transferDetails': 'Not using all of your credits on UrbanSitter? Easily transfer credits to an Outschool account registered with the same email address. Note: Credit transfers are non-refundable and cannot be undone. By completing this transaction you agree to these terms.'
      },
      'activityhero': {
        'intro': 'Instantly transfer your UrbanSitter credits to ActivityHero for camps and classes.',
        'baseUrl': 'https://www.activityhero.com/?utm_source=urbansitter&utm_medium=partner&utm_campaign=carecredits',
        'successUrl': 'https://www.activityhero.com/?utm_source=urbansitter&utm_medium=partner&utm_campaign=carecredits',
        'transferDetails': 'Easily transfer credits to an ActivityHero account registered with the same email address. Check your email for next steps from ActivityHero. Note: Credit transfers are non-refundable and cannot be undone. By completing this transaction you agree to these terms.'
      }
    },
    'parentSummary': {
      'about': 'About {{name}}',
      'affiliations': 'Affiliations:',
      'covidVaccine': 'Willing to provide proof of COVID-19 vaccine',
      'covidVaccineTooltip': 'Family is willing to provide proof that one or more adults in their household has received a COVID-19 vaccine. COVID-19 vaccination status has not been verified by UrbanSitter, nor is UrbanSitter obligated to verify the vaccination status of any user. Any request to verify COVID-19 vaccination status is your responsibility.',
      'youBothKnow': 'You both know:',
      'otherFriends': '+{{count}} other friends',
      'showLess': 'Show less',
      'familiesFromCompany_one': '{{count}} family from your company',
      'familiesFromCompany_other': '{{count}} families from your company',
      'familiesFromGroup_one': '{{count}} family from {{name}}',
      'familiesFromGroup_other': '{{count}} families from {{name}}',
      'moreGroups_one': '+ {{count}} more group',
      'moreGroups_other': '+ {{count}} more groups',
      'toggleAriaLabel': 'Toggle about section'
    },
    'outschoolCard': {
      'button': 'Get started',
      'details': '4,000+ expert tutors to help your kid (ages 3-18) develop the skills they need to succeed. Find affordable, top-notch tutors who will help your kids crush their academic goals and gain confidence.',
      'class1': 'English',
      'class2': 'Math',
      'class3': 'Science',
      'class4': 'Spanish',
      'class5': 'Reading',
      'class6': 'Test-Prep',
      'outschool': 'Outschool',
      'price': '$14+ per class',
      'subtitle': 'Foster confidence with online tutoring.'
    },
    'publicFacilityCard': {
      'ageGroup': 'Age Group',
      'classAndPhilosophies': 'Class and Philosophies',
      'contactForHours': 'Contact for hours',
      'contactForRates': 'Contact for rates',
      'hours': 'Hours',
      'notAvailable': 'N/A',
      'openSpots': 'Open spots!',
      'readMore': 'Read More',
      'review_one': '- {{count}} Review',
      'review_other': '- {{count}} Reviews',
      'tuition': 'Tuition',
      'seeDetails': 'See details',
    },
    'agencySearchCard': {
      'button': 'Learn more',
      'details': 'UrbanSitter partners with top care agencies to send the best vetted caregiver for your needs straight to you for a simple, stress-free experience.',
      'title': 'Agency Care',
      'price': '$14+ per class',
      'subtitle': 'Let us handle everything!'
    },
    'sitterCard': {
      'activeAgo': 'active {{activeAgo}}',
      'ariaLabel': 'View {{sitterName}}\'s profile',
      'rate': '${{rate}} /hr',
      'repeatFamilies': '{{repeatFamilies}} repeat families',
      'yearsExp': '{{yearsExp}} yrs exp'
    },
    'sitterSearchCard': {
      'activeAgo': 'active {{activeAgo}}',
      'ariaLabel': 'View {{sitterName}}\'s profile',
      'book': 'Book',
      'favoriteAria': 'Add {{sitterName}} to favorites',
      'unfavoriteAria': 'Remove {{sitterName}} from favorites',
      'playVideoAria': 'Play {{sitterName}}\'s introduction video',
      'rate': '${{rate}} /hr',
      'distance_one': '{{count}} mile away',
      'distance_other': '{{count}} miles away',
      'badges': {
        'backgroundCheck': 'Background check completed on {{date}}',
        'covidConsented': 'Caregiver is willing to provide proof of COVID-19 vaccine. COVID-19 vaccination status has not been verified by UrbanSitter, nor is UrbanSitter obligated to verify the vaccination status of any user. Any request to verify COVID-19 vaccination status is your responsibility.'
      },
      'selfBadge': {
        'completedBookings_one': '{{count}} completed booking with you.',
        'completedBookings_other': '{{count}} completed bookings with you.',
        'lastMessaged': 'Last messaged on {{date}}.',
        'positiveReview': 'You gave a positive review.'
      },
      'connections': {
        'singleFriend': '{{name}} is connected with this caregiver',
        'singleFriendFallback': 'A friend is connected with this caregiver',
        'multipleFriends': '{{count}} people in your network are connected with this caregiver.',
        'company': 'Families from your company are connected with this caregiver',
        'school': 'This caregiver has worked with families in {{count}} of your school groups',
        'affiliation': 'This caregiver has worked with families in {{count}} of your connected groups',
        'localGroup': 'This caregiver has worked with families in {{count}} of your connected groups'
      },
      'highlight': {
        'repeatFamilies_one': 'Booked by {{count}} repeat family',
        'repeatFamilies_other': 'Booked by {{count}} repeat families',
        'experiencePrefix': 'Experience: ',
        'experienceInfants_one': '{{shortLabel}} year with infants',
        'experienceInfants_other': '{{shortLabel}} years with infants',
        'experienceToddlers_one': '{{shortLabel}} year with toddlers',
        'experienceToddlers_other': '{{shortLabel}} years with toddlers',
        'experienceSchool_one': '{{shortLabel}} year with school aged',
        'experienceSchool_other': '{{shortLabel}} years with school aged'
      },
      'menu': {
        'ariaLabel': 'More options for {{sitterName}}',
        'message': 'Message',
        'interview': 'Interview',
        'pass': 'Pass for This Search',
        'show': 'Show in This Search'
      }
    },
    'fixedFooter': {
      'home': 'Home',
      'search': 'Search',
      'savedSearch': 'Saved Search',
      'posts': 'Posts',
      'bookings': 'Bookings'
    },
    'sittersFilter': {
      'header': 'Filters',
      'clear': 'Clear',
      'distance': 'Distance',
      'distanceOption_one': 'within {{count}} mile',
      'distanceOption_other': 'within {{count}} miles',
      'rateHeader': 'Rate per hour: ',
      'rateAndUnder': '${{maxRate}} and under',
      'rateAny': 'any',
      'rateUnder': 'Under',
      'ratePerHour': 'per hour',
      'rateMaxAriaLabel': 'Maximum rate per hour',
      'acceptsCreditCard': 'Accepts credit card',
      'certifications': 'Certifications',
      'languages': 'Languages',
      'teachingSkills': 'Teaching skills',
      'specialSituations': 'Special situations',
      'specialExperiences': 'Special experiences',
      'specialServices': 'Special services',
      'loading': 'Loading...',
      'name': 'Name:',
      'clearName': 'Clear name filter',
      'searchByName': 'Search caregivers by name',
      'caregiverNameAriaLabel': 'Caregiver name',
      'search': 'Search'
    },
    'modals': {
      'bookingAgencySuccess': {
        'title': "Your booking request has been sent. Our UrbanSitter agency concierge is working on finalizing the details, and we'll contact you by the next business\u00A0day.",
        'body': "Please note: Depending on when your job starts, there may be a delay before it's filled. Thanks for your patience! We'll be in touch\u00A0soon."
      },
      'bookingRecurringSuccess': {
        'title': 'Sending, awaiting final\u00A0confirmation',
        'body': 'We will let you know once {{firstName}} responds or if there are any availability\u00A0conflicts.'
      },
      'parentPaywall': {
        'body': 'All plans include full access to your community\'s most trusted caregivers, plus easy on-demand booking and payment.',
        'cta': {
          'selectPlan': 'Select plan',
          'upgrade': 'Upgrade now',
          'addPaymentMethod': 'Add payment method',
        },
        'genericError': 'Sorry, something unexpected went wrong. Please check your details and try again.',
        'headers': {
          'selectPlan': 'Select a plan',
          'contactSitter': 'Select a plan to contact {{name}}',
        },
        'payment': {
          'cardDetails': 'Card details',
          'change': 'change',
          'discountApplied': 'Discount applied',
          'header': 'Join us today',
          'membership': 'Membership',
          'paymentPolicies': 'Auto-renewal, payment, subscription, cancellation, and refund policies',
          'securedByStripe': 'Secured by Stripe',
          'termsAgreement': 'By checking this box, I confirm that I have reviewed and agree to the auto-renewal, payment, subscription,' +
            ' cancellation, and refund policies in UrbanSitter\'s Terms of Service.',
          'todayOnlyDiscount': 'Today only discount',
          'total': 'Total',
          'totalDiscount': 'Total discount',
          'voucherApplyButton': 'Apply',
          'voucherApplyLabel': 'Apply discount',
          'voucherApplyPlaceholder': 'Promo code',
          'voucherAppliedSuccess': 'Promo credit applied',
          'voucherSavedNotApplied': "Promo credit saved! It won't apply to this purchase, but will be applied to the next eligible transaction.",
          'voucherSuccess': 'Promo credit applied!',
          'voucherLabelSingle': '{{name}}',
          'voucherLabelMultiple': '{{name}} and {{remaining}} more',
        },
        'renewalOffer': {
          'title': 'Renewal offer terms',
          'body': 'Monthly, Quarterly, and Annual Memberships continue and automatically renew for the same membership period' +
            ' (e.g., monthly, quarterly, or annually)' +
            ' until you cancel. Unless you cancel before your Membership renews or, if you have a corporate membership,' +
            ' before the expiration of your corporate membership, you will be charged the then-current' +
            ' Membership rate (which is subject to change) for your plan. You may cancel anytime via your Account Settings,' +
            ' and your cancelation will be effective at the end of your current Membership term. Memberships are' +
            ' non-refundable.',
        },
        'termsAgreement': 'By clicking the button, you agree to the renewal offer terms\u00A0provided.',
      },
      'bookingSuccess': {
        'agencyTitle': 'Booking requested',
        'agencyBody': 'An UrbanSitter agency manager will reach out shortly to confirm your booking details.',
        'promoTitle': "You're all set!",
        'promoBodyDefault': '{{recipientName}} will reach out soon.',
        'promoBodyDefaultRecipient': 'The caregiver',
        'defaultTitle': 'Sending, awaiting final confirmation',
        'defaultBody': 'We will let you know once <recipient>{{recipientName}}</recipient> responds or if there are any availability conflicts.',
        'defaultRecipient': 'the caregiver',
        'ok': 'OK'
      },
      'interestWarning': {
        'title': 'Are you sure about {{caregiverName}}?',
        'defaultCaregiver': 'this caregiver',
        'body': 'Other caregivers have already expressed interest in this job. You can still send this request, but consider messaging those applicants first.',
        'goBack': 'Go back',
        'sendAnyway': 'Send anyway'
      },
      'multipleSitter': {
        'header': 'Duplicate date and time',
        'question': 'Would you like to book the first caregiver who accepts your job?',
        'info': 'It’s okay to send multiple requests to make sure you get a caregiver! The first caregiver to accept will be booked and the other caregivers will be notified.',
        'firstAccepter': 'Yes, book the first caregiver who accepts',
        'multipleNeeded': 'No, I need more than one caregiver'
      },
      'switchPayment': {
        'title': 'Change payment type',
        'bodyDefault': 'Change payment type for this booking?',
        'bodyToCash': "Are you sure you want to switch to cash? You'll pay the caregiver directly and won't see the booking on your UrbanSitter transactions list.",
        'bodyToCredit': "Are you sure you want to pay by credit card? We'll charge the card on file when the caregiver confirms hours.",
        'confirm': 'Yes, change to {{nextType}}',
        'success': 'Payment changed to {{nextType}}',
        'failure': "Couldn't change payment. Try again.",
        'paymentTypeCredit': 'credit card',
        'paymentTypeCash': 'cash'
      },
      'reviewFAQ': {
        'title': 'About reviews on UrbanSitter',
        'q1': 'Who can see my review?',
        'a1': "Your full review is private to you and the caregiver involved. Only a rating and short quote from you may appear on the caregiver's public profile.",
        'q2': 'Can I change my mind later?',
        'a2': 'Yes — reach out to <careLink>care@urbansitter.com</careLink> within 30 days and we’ll update or remove your review.',
        'q3': 'How do you handle safety concerns?',
        'a3': "Flag any safety issue with the report option on the caregiver's profile — our Trust & Safety team investigates every report.",
        'gotIt': 'Got it'
      },
      'photoGuide': {
        'title': 'Photo guide',
        'gotIt': 'Got it',
        'tips': {
          'clearPhoto': 'Use a clear, well-lit photo that shows your face.',
          'aloneInFrame': 'You should be the only person in the frame.',
          'noObstructionsParent': 'Skip sunglasses, hats, or filters — caregivers want to recognize you.',
          'noObstructionsSitter': 'Skip sunglasses, hats, or filters — families want to recognize you.',
          'smileParent': 'Smile! A friendly photo attracts more caregivers to your jobs.',
          'smileSitter': 'Smile! Your profile will attract more bookings.'
        }
      },
      'savedSearch': {
        'title': '{{vertical}} Search',
        'bodyInit': 'While You Wait:',
        'body': "We've set up a search for caregivers who match your needs. See available options and get notified when new matches are found.",
        'button': 'See all results',
        'notifications': 'Notifications',
        'seniors': 'seniors',
        'senior': 'senior',
        'pets': 'pets',
        'pet': 'pet',
        'children': 'children',
        'child': 'child',
        'jobPost': {
          'title': 'My job',
          'type': 'Type of job',
          'showRatesFor': 'Show rates for',
          'createdOn': 'Created on',
          'button': 'Go to job post'
        },
        'notificationType': {
          'never': 'Never',
          'instantly': 'Instantly',
          'daily': 'Daily',
          'weekly': 'Weekly'
        }
      },
      'backgroundCheckRenew': {
        'title': 'Background check renewal',
        'later': 'Later',
        'renewNow': 'Renew now',
        'expiresOn': 'Your background check expires on <b>{{date}}</b>.',
        'expiringSoon': 'Your background check is expiring soon.',
        'body': 'Renew now to keep appearing in family searches without interruption.'
      },
      'cancelBooking': {
        'title': 'Cancel booking',
        'keep': 'Keep booking',
        'submit': 'Cancel booking',
        'cancelled': 'Booking cancelled',
        'submitError': "Couldn't cancel. Try again.",
        'reasonLabel': 'Reason for cancelling',
        'reasonPrompt': 'Please select',
        'reasonRequired': 'Please select a reason to cancel',
        'reasonOtherLabel': 'Explain',
        'reasonOtherRequired': 'Please explain what you mean by "Other"',
        'messageLabel': 'Message to the {{role}}',
        'messageRequired': 'A message to the {{role}} is required',
        'charactersRemaining': '{{count}} characters remaining',
        'parent': 'parent',
        'sitter': 'sitter'
      },
      'declineBooking': {
        'title': 'Decline booking',
        'success': 'Booking declined',
        'submitError': "Couldn't decline. Try again.",
        'messageRequired': 'A message to the family is required.',
        'intro': "Let {{name}} know why you can't take this one.",
        'introFallbackName': 'the family',
        'charactersRemaining': '{{count}} characters remaining',
        'messageAriaLabel': 'Message to family'
      },
      'flagProfile': {
        'title': 'Why are you reporting this profile?',
        'pleaseSelect': 'Please Select',
        'reasonAriaLabel': 'Reason',
        'commentAriaLabel': 'Comment',
        'reasonRequired': 'Please select a reason for flagging this profile',
        'commentRequired': 'Please provide a comment',
        'genericError': 'Something went wrong. Please try again soon.',
        'thanksHeading': 'Thanks for your feedback',
        'thanksFooter': 'Thanks, from UrbanSitter.',
        'reasons': {
          'inappropriateOffensive': 'This profile is inappropriate/offensive',
          'misleadingSuspicious': 'This profile is misleading/suspicious',
          'poorExperience': 'I had a poor experience with this individual',
          'discriminatory': 'This individual or their profile is discriminatory'
        }
      },
      'profileVideo': {
        'defaultTitle': 'Profile video',
        'noVideo': 'No video uploaded.'
      },
      'sitterNote': {
        'title': 'Save private note about caregiver',
        'charactersRemaining': '{{count}} characters remaining',
        'noteAriaLabel': 'Private note',
        'privacyHint': 'This information is only visible to you',
        'saveError': "Couldn't save note. Try again.",
        'saveErrorToast': "Couldn't save note."
      }
    },
    'sitterProfile': {
      'labels': {
        'englishColon': 'English:',
        'languagesColon': 'Languages:',
        'covidVaccineColon': 'COVID-19 Vaccine:',
        'otherServicesHeading': 'Other Services Provided',
        'otherServicesEmpty': 'Willingness to provide other services has not been specified',
        'petCare': 'Pet Care',
        'householdServices': 'Household Services',
        'seniorCare': 'Senior Care',
        'childrensAgesHeading': "Children's ages",
        'infants': 'Infants',
        'toddlers': 'Toddlers',
        'schoolAge': 'School age',
        'ratesHeading': 'Rates',
        'noInfo': 'No information available',
        'openToFlatRates': 'Open to flat rates for part-time and full-time jobs',
        'willingExclusive': 'Willing to work with one family exclusively, given a weekly hours commitment',
        'teachingSkillsHeading': 'Teaching skills',
        'specialExperienceHeading': 'Special experience',
        'willingToHelpHeading': 'Willing to help with...',
        'noSpecificDuties': 'No specific duties specified',
        'specialSituationsHeading': 'Special situations',
        'noSituations': 'No situations listed',
        'educationHeading': 'Education',
        'collegeColon': 'College:',
        'graduatedFromColon': 'Graduated from:',
        'currentlyAttendingColon': 'Currently attending:',
        'areaOfStudyColon': 'Area of study:',
        'graduationDateColon': 'Graduation date:',
        'expectedGraduationDateColon': 'Expected graduation date:',
        'certificationsHeading': 'Certifications',
        'livesInColon': 'Lives in:',
        'neighborhoodColon': 'Neighborhood:',
        'addNeighborhood': 'Add neighborhood',
        'willingToWorkWithinColon': 'Willing to work within:'
      },
      'rates': {
        'minimumError': 'Minimum rate must be at least $8.',
        'ratesByCountHeading': 'Rates by number of children, seniors, or pets:',
        'maxHeading': 'Children, seniors, or pets maximum:',
        'minHoursHeading': 'Minimum hours per job',
        'considerationsHeading': 'Considerations for part-time or full-time jobs:',
        'openToFlatRates': 'Open to flat weekly/monthly rates',
        'willingExclusive': 'Willing to work with one family exclusively, given a weekly hours commitment'
      }
    },
  },
  'validation': {
    'errors': {
      'invalidState': 'Please provide a valid state code',
      'invalidZip': 'Please provide a valid zip code',
    }
  },
}
